import { render, staticRenderFns } from "./ModalProcedimentosIncluir.vue?vue&type=template&id=01c2c2cf&scoped=true"
import script from "./ModalProcedimentosIncluir.vue?vue&type=script&lang=ts"
export * from "./ModalProcedimentosIncluir.vue?vue&type=script&lang=ts"
import style0 from "./ModalProcedimentosIncluir.vue?vue&type=style&index=0&id=01c2c2cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c2c2cf",
  null
  
)

export default component.exports